import React, {useEffect, useState} from 'react';
import {Trail} from "types/Trail";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "../../../context/NotificationContext";
import {useOperator} from "../../../context/OperatorContext";

type Props = {
    trail?: Trail | null
    show: boolean
    onDelete?: (trail: Trail) => any
    onDeleteFail?: (trail: Trail, error: unknown) => any
    onCancel?: () => any
}

function DeleteTrail({trail, show, onDelete, onDeleteFail, onCancel}: Props) {
    const {termFor} = useOperator()
    const {notify} = useNotifications()

    const [name, setName] = useState<string>(trail?.name || `this ${termFor('trail')}`);
    const {mutateAsync: deleteTrail} = useMutation(ngage.trails.destroy)

    useEffect(() => {
        if(trail) setName(trail.name)
    }, [trail]);

    async function handleDeleteTrail() {
        if (trail) {
            try {
                await deleteTrail(trail.id)
                await invalidate('trails.all')

                notify("success", `${termFor('Trail')} Deleted`, `${trail.name} has been permanently removed`)
                if (onDelete) onDelete(trail)
            } catch (error) {
                notify("error", `${termFor('Trail')} Not Deleted`, `${trail.name} could not be removed`)
                if (onDeleteFail) onDeleteFail(trail, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title={`Delete ${termFor('Trail')}`}
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteTrail}
            onCancel={handleCancel}
        />
    );
}

export default DeleteTrail;